import React from "react";
import Video from "../assets/images/video.mp4";
import SchoolImage from "../assets/images/School.jpg";
import MicImage from "../assets/images/Mic.jpg";
import DelImage from "../assets/images/Del.jpeg";
import { useNavigate } from "react-router-dom";
import "./styles/About.scss";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      {/* Welcome Video */}
      <div className="video-container">
        <video autoPlay loop muted className="background-video">
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay">
          <h1>Welcome to the Del Couch Music Education Foundation</h1>
          <p>Empowering lives through the love of music.</p>
        </div>
      </div>

      {/* Location Section */}
      <section className="about-section">
        <div className="text-container">
          <h2>Our Location and Facilities</h2>
          <p>
            The Foundation is located at the Manatee School for the Arts. We
            have an ultra-modern recording studio where we teach kids about
            audio production and the music industry.
          </p>
        </div>
        <div className="image-container">
          <img src={SchoolImage} alt="Manatee School for the Arts" />
        </div>
      </section>

    {/* Empowering Lives Section */}
<section className="about-section">
  <div className="text-container">
    <h2>Empowering Lives Through Music</h2>
    <p>
      At the Del Couch Music Education Foundation, we believe in the transformative power of music. 
      Our programs are designed to provide students with access to state-of-the-art facilities and resources 
      that inspire creativity and self-expression.
    </p>
    <p>
      Students learn to compose, record, and produce music in a professional-grade studio, gaining skills that
      prepare them for careers in the music industry. Beyond technical skills, we focus on building confidence, 
      teamwork, and a sense of achievement through music.
    </p>
    <p>
      Our mentorship program connects students with seasoned professionals who guide them through every 
      step of their musical journey. From mastering instruments to understanding the business of music, 
      we ensure that each student has the tools they need to succeed.
    </p>
    <p>
      Many of our students have gone on to achieve remarkable success, performing on national stages 
      and building careers in music. Join us and discover how music can empower and transform lives.
    </p>
  </div>
  <div className="image-container">
    <img src={MicImage} alt="Microphone in the studio" />
  </div>
</section>

      {/* History and Achievements Section */}
      <section className="about-section">
        <div className="text-container">
          <h2>Our Story and Achievements</h2>
          <p>
            The Del Couch Music Education Foundation offers children free access
            to music education, recording equipment, and mentorship. Located
            inside the Manatee School for the Arts in Palmetto, Florida, the
            foundation provides comprehensive training in music recording and
            production, alongside performance opportunities through events and
            mentorships.
          </p>
          <p>
            Alumni include notable figures such as Sam Woolf (American Idol
            finalist), singer-songwriter Matt Walden, Carolina Opry star Colton
            Cason, and Christian artist Taylor Zebracki. The foundation has also
            mentored other talented individuals, like Andy Pursell, David Smash,
            and Trevor Bystrom, all of whom have gone on to achieve significant
            success.
          </p>
          <p>
            Del Couch began his musical journey playing the trumpet and formed
            an award-winning brass band recognized by Herb Alpert. After serving
            in the United States Air Force Band and building a successful career
            in real estate, he returned to music production, earning a master’s
            degree from the Berklee College of Music. His passion for mentoring
            young talent led to the creation of this foundation, which has
            positively impacted countless lives.
          </p>
        </div>
        {/*DIV TEXT CONTAINERS ADDED BEFORE THIS LINE, CHECK TO SEE IF THEY WORK BEFORE CONTINUING*/}
        <div className="image-container">
          <img src={DelImage} alt="Del Couch" />
          <ul>
            <li>Grammy Awards Educator of the Year Nominee</li>
            <li>Mentorship of American Idol finalist Sam Woolf</li>
            <li>Partnerships with national artists and producers</li>
            <li>Development of professional music studios and curricula</li>
          </ul>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="about-section">
        <div className="text-container">
          <h2>Join Us</h2>
          <p>
            Want to be part of our journey? Whether you’re a student, a mentor,
            or a supporter, we welcome you to join our community.
          </p>
          <button className="button" onClick={() => navigate("/Contact")}>
            Contact Us
          </button>
        </div>
      </section>
    </div>
  );
};

export default About;
